import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { Fade } from '@material-ui/core';
import { withTheme } from '@material-ui/core/styles';
import * as actions from '../../actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { FormattedMessage } from 'react-intl';
import { Scrollbars } from 'react-custom-scrollbars';

class BookingTimeSlotPopup extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loaderButton: false,
            selectedVariant: 'outlined',
            closeVerification: false,
            selectedSlot: ''
        };
    }

    handleClose = () => {
        this.props.closePopup();
    };

    handleError = params => {
        this.setState(params);
    };
    onSlotPress = slot => () => {
        this.setState({ selectedSlot: slot });
        this.props.onTimeSlotSelected(slot);
    };
    render() {
        const { slots } = this.props;
        const { selectedSlot } = this.state;
        return (
            <div>
                <Dialog
                    fullWidth={true}
                    maxWidth={'sm'}
                    TransitionComponent={Fade}
                    className="service-modal booking-date-time-pop"
                    open={this.props.isVisible}
                    onClose={this.handleClose}
                    aria-labelledby="form-dialog-title"
                >
                    <div
                        className="modal-header dir-pop-head"
                        style={{
                            backgroundColor: this.props.theme.palette.primary
                                .main
                        }}
                    >
                        <h4 className="dialog-heading">
                            <FormattedMessage
                                id="timeslot.choosetitle"
                                defaultMessage="Choose Available Slots"
                            />
                        </h4>
                    </div>
                    <div className="modal-body dir-pop-body">
                        <DialogContent className="service-from-body">
                            <Scrollbars>
                                <div className="row justify-content-center" justify="center">
                                    {slots.map(slot => {
                                        return (
                                            <div
                                                className="col-md-4 col-5 btn-width-100"
                                                style={{ marginBottom: 10 }}
                                                key={
                                                    slot.start + `-` + slot.end
                                                }
                                            >
                                                <Button
                                                    variant={
                                                        selectedSlot == slot
                                                            ? 'contained'
                                                            : 'outlined'
                                                    }
                                                    color="primary"
                                                    key={slot.key}
                                                    onClick={this.onSlotPress(
                                                        slot
                                                    )}
                                                    disabled={!slot.status}
                                                >
                                                    {slot.label}
                                                </Button>
                                            </div>
                                        );
                                    })}
                                    <div className="col-md-12">
                                        <div className="text-center">
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={this.handleClose}
                                            >
                                                <FormattedMessage
                                                    id="timeslot.book"
                                                    defaultMessage="Book"
                                                />
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </Scrollbars>
                        </DialogContent>
                    </div>
                </Dialog>
            </div>
        );
    }
}

const composedHOC = compose(
    withTheme(),

    connect(
        null,
        actions
    )
);
export default composedHOC(BookingTimeSlotPopup);



// WEBPACK FOOTER //
// ./src/components/Booking/BookingTimeSlotPopup.jsx